import Timestamp from "components/Timestamp";
import Box from "ds/components/Box";
import Link from "ds/components/Link";
import Tile from "ds/components/Tile";
import TileTitle from "ds/components/Tile/Title";
import Typography from "ds/components/Typography";
import { SearchSpaceliftVcsRepoCommitsItem } from "shared/SpaceliftVcsRepo/useSearchSpaceliftVcsRepoCommits/gql";
import { getRepoRevisionUrl } from "utils/spaceliftRepo";

import { SHORT_SHA_LENGTH } from "../../constants";

type SpaceliftVcsRepoCommitsItemProps = {
  commit: SearchSpaceliftVcsRepoCommitsItem;
  repoId: string;
};

const SpaceliftVcsRepoCommitsItem = ({ commit, repoId }: SpaceliftVcsRepoCommitsItemProps) => {
  const shortSha = commit.sha.slice(0, SHORT_SHA_LENGTH);
  const commitUrl = getRepoRevisionUrl(repoId, commit.sha);

  return (
    <Tile
      title={
        <Link variant="secondary" href={commitUrl}>
          <TileTitle>
            <span>({shortSha})</span> {commit.message}
          </TileTitle>
        </Link>
      }
    >
      {commit.description && (
        <Typography variant="p-body3" tag="p" color="secondary">
          {commit.description}
        </Typography>
      )}

      <Box>
        <Typography color="secondary" variant="p-body3" tag="p">
          {commit.authorEmail || commit.authorName}&nbsp;-&nbsp;
        </Typography>

        <Timestamp timestamp={commit.createdAt} color="secondary" />
      </Box>
    </Tile>
  );
};

export default SpaceliftVcsRepoCommitsItem;
